var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<button class="CDB-Widget-button CDB-Widget-errorButton js-refresh">\n  <span class="CDB-Widget-textSmall CDB-Widget-textSmall--bold">REFRESH</span>\n</button>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/widget-error-template.tpl
// module id = 883
// module chunks = 2 3